import createBrowserHistory from 'history/createBrowserHistory';

export default createBrowserHistory({
  /* pass a configuration object here if needed */
});
